var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`
    label-outlined-component-container
    ${!_vm.is_disabled
      ? 'label-outlined-component-container-active'
      : ''
    }
    ${_vm.dark
      ? _vm.is_ready
        ? 'label-outlined-component-container-dark-ready'
        : 'label-outlined-component-container-dark'
      : _vm.is_ready
        ? 'label-outlined-component-container-light-ready'
        : 'label-outlined-component-container-light'
    }`,style:(`
    ${_vm.width
      ? `min-width: ${_vm.width}; max-width: ${_vm.width};`
      : 'width: 100%;'
    }
    min-height: ${_vm.height || 0}px;
    margin-top: ${_vm.label ? '5px' : ''};
    ${_vm.is_disabled?'cursor: default':''}
  `)},[(_vm.label)?_c('div',{class:`label-outlined-component-top-label ${_vm.background_color.substring(0,1) !== '#' ? _vm.background_color : ''}`,style:(`${_vm.background_color.substring(0,1) === '#' ? `background-color: ${_vm.background_color}` : ''};`)},[_c('TText',{attrs:{"value":`${_vm.label}`,"color":_vm.dark ? '#000' : '#FFF',"size":8,"font_weight":"300"}}),(_vm.label_suffix)?_c('TText',{attrs:{"text":`${_vm.label_suffix}`,"color":_vm.dark ? '#000' : '#FFF',"size":8,"font_weight":"300"}}):_vm._e()],1):_vm._e(),_c('div',{staticClass:"label-outlined-component-content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }